import { useGetProcessingRuleByIdQuery } from '../queries';

const useProcessingRuleById = (ruleId?: string, enabled = true) => {
  const { rule, ruleOption, isLoading, isFetching } = useGetProcessingRuleByIdQuery(ruleId, enabled);

  return {
    rule,
    ruleOption,
    isLoading: isLoading || isFetching,
  };
};

export default useProcessingRuleById;
